import React, { useEffect, useState } from "react";
import Button from "@components/button";
import Checkbox from "@components/checkbox";
import styles from "./Balance.module.css";
import * as apiUser from "@api/user";
//import { useDispatch } from "react-redux";

const Balance = () => {
  //const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [creditOptions, setCreditOptions] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState(null);

  // Load options on mount
  useEffect(() => {
    const loadOptions = async () => {
        const options = await apiUser.GetCreditBuyOptions();
        setCreditOptions(options);
    };

    loadOptions();
  }, []);

  const handleSelect = (quantity) => {
    setSelectedQuantity(quantity);
  };

  const onClickAcquista = async () => {
    if (!selectedQuantity) return;
    setLoading(true);

    try {
      const result = await apiUser.StartPayment({
        service: 3, // BuyCredit
        quantity: selectedQuantity,
      });
      window.location = result;
    } catch (e) {
      console.error("Payment error", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <br />
      <div className="row">
        <div className="col">
          <span>
            I crediti servono per comprare annunci e servizi su La Soffiata. Quanti ne vuoi acquistare?
          </span>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col">
          {creditOptions.map((option) => (
            <div
              key={option.quantity}
              className={styles.option + (selectedQuantity === option.quantity ? " " + styles.selected : "")}
              onClick={() => handleSelect(option.quantity)}
            >
              <Checkbox value={selectedQuantity === option.quantity} setValue={() => handleSelect(option.quantity)} />
              <span>{option.quantity} crediti - €{option.price.toFixed(2)}</span>
            </div>
          ))}
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col">
          <Button
            color="primary"
            disabled={loading || selectedQuantity === null}
            fullWidth
            onClick={onClickAcquista}
            text="Acquista"
          />
        </div>
      </div>
    </>
  );
};

export default Balance;